interface PathData {
  data: string;
  fill?: string;
  strokeWidth?: number;
  stroke?: string;
}

export interface Icon {
  viewbox: string;
  paths: PathData[];
}

export const Icons = {
  Plus: {
    viewbox: '-0.75 -0.75 24 24',
    paths: [
      {
        fill: 'none',
        stroke: 'currentcolor',
        strokeWidth: 1.5,
        data: 'M11.25 0.9375v20.625',
      },
      {
        fill: 'none',
        stroke: 'currentcolor',
        strokeWidth: 1.5,
        data: 'M0.9375 11.25h20.625',
      },
    ],
  } as Icon,
  Upward: {
    viewbox: '0 0 24 24',
    paths: [
      {
        fill: 'none',
        stroke: 'currentcolor',
        strokeWidth: 1.5,
        data: 'M11.5 22.5v-21M5.5 7.5l6-6 6 6',
      },
    ],
  } as Icon,
  Forward: {
    viewbox: '0 0 24 24',
    paths: [
      {
        fill: 'none',
        stroke: 'currentcolor',
        strokeWidth: 1.5,
        data: 'M1 12h21M16 6l6 6-6 6',
      },
    ],
  } as Icon,
  Backwards: {
    viewbox: '0 0 24 24',
    paths: [
      {
        fill: 'none',
        stroke: 'currentcolor',
        strokeWidth: 1.5,
        data: 'M23 12H2M8 18l-6-6 6-6',
      },
    ],
  } as Icon,
  External: {
    viewbox: '0 0 24 24',
    paths: [
      {
        fill: 'none',
        stroke: 'currentcolor',
        strokeWidth: 1.5,
        data: 'M12 5H2v17h17V12M10 14 22 2M14 2h8v8',
      },
    ],
  } as Icon,
  Contact: {
    viewbox: '0 0 24 24',
    paths: [
      {
        fill: 'none',
        stroke: 'currentcolor',
        strokeWidth: 1.5,
        data: 'M18 7.5V2H2v16l4-2.5h2',
      },
      {
        fill: 'none',
        stroke: 'currentcolor',
        strokeWidth: 1.5,
        data: 'M10 9.5V19h8l4 2.5v-12H10Z',
      },
    ],
  } as Icon,
  Menu: {
    viewbox: '0 0 24 24',
    paths: [
      {
        fill: 'none',
        stroke: 'currentcolor',
        strokeWidth: 1.5,
        data: 'M1 2h22M1 12h22M1 22h22',
      },
    ],
  } as Icon,
  Close: {
    viewbox: '0 0 24 24',
    paths: [
      {
        fill: 'none',
        stroke: 'currentcolor',
        strokeWidth: 1.5,
        data: 'm1.5 1.5 21 21m0-21-21 21',
      },
    ],
  } as Icon,
  Overview: {
    viewbox: '0 0 24 24',
    paths: [
      {
        fill: 'none',
        stroke: 'currentcolor',
        strokeWidth: 1.5,
        data: 'M2 2h16v16H2V2Z',
      },
      {
        fill: 'none',
        stroke: 'currentcolor',
        strokeWidth: 1.5,
        data: 'M22 5v17H5',
      },
    ],
  } as Icon,
  LinkedIn: {
    viewbox: '-0.75 -0.75 24 24',
    paths: [
      {
        fill: 'none',
        stroke: 'currentcolor',
        strokeWidth: 1.5,
        data: 'M1.875 9.375h3.75v11.25h-3.75zM20.625 20.625V15A5.625 5.625 0 0 0 15 9.375H8.90625v11.25h3.75v-7.5h1.40625a2.8125 2.8125 0 0 1 2.8125 2.8125v4.6875h3.75ZM1.875 2.8125h3.75v3.75h-3.75z',
      },
    ],
  } as Icon,
};

export { _icons as SolutionIcons } from './icons.solutions';
